import React from 'react'
import PropTypes from 'prop-types'

import { getEngineDisplayName } from 'app/views/utils/engine'

const ENGINE_INFO = {
  c: {
    versionStrings: [
      ['Compiler Version', 'gcc 10.3.0'],
    ],
  },
  dotnet: {
    versionStrings: [
      ['.NET Version', 'Mono 6.12.0'],
    ],
    libraries: [
      ['AsyncIO (0.1.26.0)', 'https://github.com/somdoron/AsyncIO'],
      ['Google.Protobuf (3.5.1)', 'https://github.com/protocolbuffers/protobuf'],
      ['Microsoft.IdentityModel.JsonWebTokens (5.2.4)', 'https://github.com/AzureAD/azure-activedirectory-identitymodel-extensions-for-dotnet'],
      ['Microsoft.IdentityModel.Logging (5.2.4)', 'https://github.com/AzureAD/azure-activedirectory-identitymodel-extensions-for-dotnet'],
      ['Microsoft.IdentityModel.Tokens (5.2.4)', 'https://github.com/AzureAD/azure-activedirectory-identitymodel-extensions-for-dotnet'],
      ['MySql.Data (8.0.11)', 'https://www.nuget.org/packages/MySql.Data'],
      ['NetMQ (4.0.0.1)', 'https://github.com/zeromq/netmq.git'],
      ['Newtonsoft.Json (11.0.2)', 'https://github.com/JamesNK/Newtonsoft.Json'],
      ['System.IdentityModel.Tokens.Jwt (5.2.4)', 'https://github.com/AzureAD/azure-activedirectory-identitymodel-extensions-for-dotnet'],
      ['System.DirectoryServices (4.5.0)', 'https://github.com/dotnet/runtime'],
      ['MongoDB.Driver (2.9.1)', 'https://www.nuget.org/packages/MongoDB.Driver'],
      ['System.Net.Http (4.3.4)', 'https://www.nuget.org/packages/System.Net.Http'],
    ],
  },
  clojure: {
    versionStrings: [
      ['Clojure Version', '1.10.1'],
    ],
    libraries: [
      ['org.clojure/java.jdbc (0.7.12)', 'https://github.com/clojure/java.jdbc'],
      ['mysql/mysql-connector-java (5.1.38)', 'http://svn.mysql.com/svnpublic/connector-j/trunk/connector-j'],
      ['ring/ring-core (1.8.2)', 'https://github.com/ring-clojure/ring'],
      ['cheshire (5.10.0)', 'https://github.com/dakrone/cheshire'],
      ['org.apache.commons/commons-text (1.9)', 'https://commons.apache.org/proper/commons-text/'],
      ['org.clojure/data.xml (0.0.8)', 'https://github.com/clojure/data.xml'],
      ['buddy/buddy-sign (3.3.0)', 'https://github.com/funcool/buddy-sign'],
      ['io.djy/ezzmq (0.4.0)', 'https://github.com/daveyarwood/ezzmq'],
    ],
  },
  go: {
    versionStrings: [
      ['Go Version', '1.16.8'],
    ],
    libraries: [
      ['github.com/dgrijalva/jwt-go (3.2.0)', 'https://github.com/dgrijalva/jwt-go'],
      ['github.com/go-sql-driver/mysql (1.6.0)', 'https://github.com/go-sql-driver/mysql'],
      ['github.com/konsorten/go-windows-terminal-sequences (1.0.2)', 'https://github.com/konsorten/go-windows-terminal-sequences'],
      ['github.com/kr/pretty (0.1.0)', 'https://github.com/kr/pretty'],
      ['github.com/pebbe/zmq4', 'https://github.com/pebbe/zmq4'],
      ['github.com/sirupsen/logrus (1.4.2)', 'https://github.com/sirupsen/logrus'],
      ['github.com/stretchr/testify (1.7.0)', 'https://github.com/stretchr/testify'],
      ['golang.org/x/net', 'https://cs.opensource.google/go/x/net'],
      ['gopkg.in/check.v1 (1.0.0)', 'https://github.com/go-check/check'],
    ],
  },
  java: {
    versionStrings: [
      ['JDK Version', 'OpenJDK 16.0.2'],
    ],
    libraries: [
      ['com.google.guava:guava (23.0)', 'https://github.com/google/guava'],
      ['org.zeromq:jeromq (0.4.3)', 'https://github.com/zeromq/jeromq'],
      ['com.googlecode.json-simple:json-simple (1.1.1)', 'https://code.google.com/archive/p/json-simple/'],
      ['mysql:mysql-connector-java (5.1.45)', 'https://mvnrepository.com/artifact/mysql/mysql-connector-java'],
      ['io.jsonwebtoken:jjwt-api (0.10.7)', 'https://github.com/jwtk/jjwt'],
      ['io.jsonwebtoken:jjwt-impl (0.10.7)', 'https://github.com/jwtk/jjwt'],
      ['io.jsonwebtoken:jjwt-jackson (0.10.7)', 'https://github.com/jwtk/jjwt'],
      ['org.apache.commons:commons-text (1.9)', 'https://commons.apache.org/proper/commons-text/'],
      ['org.apache.commons:commons-lang (3:3.7)', 'https://mvnrepository.com/artifact/org.apache.commons/commons-lang3'],
      ['org.mongodb:mongo-java-driver (2.12.3)', 'https://mvnrepository.com/artifact/org.mongodb/mongo-java-driver'],
      ['junit:junit (4.12)', 'https://mvnrepository.com/artifact/junit/junit'],
    ],
  },
  node: {
    versionStrings: [
      ['Node Version', '15.4.0'],
    ],
    libraries: [
      ['escape-html (^1.0.3)', 'https://github.com/component/escape-html'],
      ['jsdom (^17.0.0)', 'https://github.com/jsdom/jsdom'],
      ['jsonwebtoken (8.5.1)', 'https://github.com/auth0/node-jsonwebtoken'],
      ['jwt-decode (2.2.0)', 'https://github.com/auth0/jwt-decode'],
      ['libxmljs (0.19.7)', 'https://github.com/libxmljs/libxmljs'],
      ['mysql (2.17.1)', 'https://github.com/mysqljs/mysql'],
      ['zeromq (5.2.0)', 'https://github.com/zeromq/zeromq.js'],
    ],
  },
  perl: {
    versionStrings: [
      ['Perl Version', '5.32.1'],
    ],
    libraries: [
      ['DBI', 'https://metacpan.org/pod/DBI'],
      ['DBD::mysql', 'https://metacpan.org/pod/DBD::mysql'],
      ['Try::Tiny::SmartCatch', 'https://metacpan.org/pod/Try::Tiny::SmartCatch'],
      ['XML::LibXML', 'https://metacpan.org/pod/XML::LibXML'],
      ['Exception::Class', 'https://metacpan.org/pod/Exception::Class'],
      ['JSON::WebToken', 'https://metacpan.org/pod/JSON::WebToken'],
      ['CGI', 'https://metacpan.org/pod/CGI'],
      ['ZMQ::LibZMQ3', 'https://metacpan.org/pod/ZMQ::LibZMQ3'],
    ],
  },
  php: {
    versionStrings: [
      ['PHP Version', '7.2.24'],
    ],
    libraries: [
      ['firebase/php-jwt (5.0.0)', null],
      ['react/zmq (0.4.0)', null],
      ['php7.2', null],
      ['php-curl', null],
      ['php-mongodb', null],
      ['php-mysql', null],
      ['php-xml', null],
      ['php-zmq', null],
      ['libzmq3-dev', null],
    ],
  },
  python: {
    versionStrings: [
      ['Interpreter Version', 'Python 3.6.9'],
    ],
    libraries: [
      ['lxml (4.1.1)', 'https://github.com/lxml/lxml'],
      ['PyJWT (1.4.2)', 'https://github.com/jpadilla/pyjwt'],
      ['PyMySQL (0.7.11)', 'https://github.com/PyMySQL/PyMySQL'],
      ['pyzmq (17.0.0)', 'https://github.com/zeromq/libzmq'],
      ['untangle (1.1.1)', 'https://github.com/stchris/untangle'],
      ['xmltodict (0.11.0)', 'https://github.com/martinblech/xmltodict'],
    ],
  },
  ruby: {
    versionStrings: [
      ['Interpreter Version', 'Ruby 2.5.1'],
    ],
    libraries: [
      ['activesupport (6.1.3.1)', 'https://rubygems.org/gems/activesupport'],
      ['faraday (1.4.1)', 'https://github.com/lostisland/faraday'],
      ['ffi-rzmq (2.0.7)', 'https://github.com/chuckremes/ffi-rzmq'],
      ['jwt (2.2.1)', 'https://github.com/jwt/ruby-jwt'],
      ['ruby-mysql (2.9.14)', 'https://github.com/tmtm/ruby-mysql'],
      ['mongo (2.14.0)', 'https://github.com/mongodb/mongo-ruby-driver'],
      ['mysql2 (0.5.3)', 'https://github.com/brianmario/mysql2'],
      ['nokogiri (1.11.3)', 'https://github.com/sparklemotion/nokogiri'],
      ['xml-simple (1.1.5)', 'https://github.com/maik/xml-simple'],
    ],
  },
  scala: {
    versionStrings: [
      ['JDK Version', 'OpenJDK 16.0.2'],
    ],
    libraries: [
      ['org.scala-lang:scala-library (2.13.6)', 'https://mvnrepository.com/artifact/org.scala-lang/scala-library'],
      ['com.google.guava:guava (23.0)', 'https://github.com/google/guava'],
      ['org.zeromq:jeromq (0.4.3)', 'https://github.com/zeromq/jeromq'],
      ['com.googlecode.json-simple:json-simple (1.1.1)', 'https://code.google.com/archive/p/json-simple/'],
      ['mysql:mysql-connector-java (5.1.45)', 'https://mvnrepository.com/artifact/mysql/mysql-connector-java'],
      ['io.jsonwebtoken:jjwt-api (0.10.7)', 'https://github.com/jwtk/jjwt'],
      ['io.jsonwebtoken:jjwt-impl (0.10.7)', 'https://github.com/jwtk/jjwt'],
      ['io.jsonwebtoken:jjwt-jackson (0.10.7)', 'https://github.com/jwtk/jjwt'],
      ['org.apache.commons:commons-text (1.9)', 'https://commons.apache.org/proper/commons-text/'],
      ['org.mongodb:mongo-java-driver (2.12.3)', 'https://mvnrepository.com/artifact/org.mongodb/mongo-java-driver'],
      ['junit:junit (4.12)', 'https://mvnrepository.com/artifact/junit/junit'],
    ],
  },
}

const Item = ({ children }) => (
  <p style={{ margin: '6px 10px' }}>{children}</p>
)
const LibraryListColumn = ({ children }) => (
  <div style={{ flexBasis: 0, flexShrink: 0, flexGrow: 1 }}>
    {children}
  </div>
)
const LibraryListItem = ({ text, url }) => (
  <div>
    &bull; {(url && url.length > 0) ? <a href={url} rel="noreferrer" target="_blank" >{text}</a> : text}
  </div>
)
const LibraryList = ({ namesAndUrls }) => {
  const splitAtIndex = namesAndUrls.length > 3 ? Math.round(namesAndUrls.length / 2) : -1
  const columns = splitAtIndex === -1 ? [namesAndUrls] : [
    namesAndUrls.slice(0, splitAtIndex),
    namesAndUrls.slice(splitAtIndex),
  ]
  return (
    <div style={{ marginLeft: 20, marginTop: 0, display: 'flex' }}>
      {columns.map((columnNamesAndUrls, i) => (
        <LibraryListColumn key={i}>
          {columnNamesAndUrls.map(([name, url], j) => (
            <LibraryListItem key={j} text={name} url={url} />
          ))}
        </LibraryListColumn>
      ))}
    </div>
  )
}

function LanguageEnvironmentDetails(props) {
  const { engine } = props
  const versionStrings = (ENGINE_INFO[engine] || {}).versionStrings || []
  const libraryNamesAndUrls = (ENGINE_INFO[engine] || {}).libraries || []
  return (
    <div style={{ marginTop: 20 }}>
      <h4 style={{ marginBottom: 0 }}>{getEngineDisplayName(engine)} Environment</h4>
      <Item><b>Operating System:</b> Ubuntu 18.04</Item>
      {versionStrings.map(([description, value], index) => (
        <Item key={index}><b>{description}:</b> {value}</Item>
      ))}
      {libraryNamesAndUrls.length > 0 && (
        <>
          <Item><b>Third-party Libraries:</b></Item>
          <LibraryList namesAndUrls={libraryNamesAndUrls} />
        </>
      )}
    </div>
  )
}
LanguageEnvironmentDetails.propTypes = {
  engine: PropTypes.string,
}

export default LanguageEnvironmentDetails
